'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-info-notice',
    cnContent = "".concat(CLASSNAME, "__content"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function InfoNotice(_ref) {
  var className = _ref.className,
      content = _ref.content,
      iconId = _ref.iconId,
      size = _ref.size;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, "".concat(CLASSNAME, "--").concat(size))
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: iconId,
    size: {
      sm: 'xxs',
      lg: 'sm'
    }[size],
    className: cnIcon
  }), /*#__PURE__*/React__default.createElement("span", {
    className: cnContent
  }, content));
}
InfoNotice.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  content: PropTypes.string,

  /** */
  iconId: PropTypes.string,

  /** */
  size: PropTypes.oneOf(['sm', 'lg'])
};
InfoNotice.defaultProps = {
  iconId: 'info',
  size: 'sm'
};

module.exports = InfoNotice;
